export class MoneyValueObject {
  readonly currency!: 'USD'
  readonly symbol!: '$'
  readonly value!: number

  constructor(money?: Partial<MoneyValueObject>) {
    if (!money) {
      return this
    }
    this.currency = money.currency || 'USD'
    this.symbol = money.symbol || '$'
    this.value = money.value as number
  }

  toString(
    decimals: boolean = true,
    onlySuppressZeroDecimals?: boolean
  ): string {
    let value = (this.value / 100)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&,')

    if (!decimals) {
      if (onlySuppressZeroDecimals === true) {
        if (value.substr(-3) === '.00') {
          value = value.substring(0, value.length - 3)
        }
      } else {
        value = value.substring(0, value.length - 3)
      }
    }

    return value
  }
}
